import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, ArrowLeft, LogOut, Shield, ShieldAlert } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { BrandMark } from "../../components/Layout";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 flex flex-col md:flex-row">
      <aside className="surface-dark w-full md:w-64 border-r border-slate-800 p-4 flex md:flex-col justify-between md:min-h-screen">
        <div className="w-full">
          <div className="flex items-center gap-2 mb-6">
            <Shield className="text-amber-500" size={22} />
            <div><p className="font-extrabold text-white leading-none">Super-Admin</p><p className="text-[11px] text-slate-400">Control Console</p></div>
          </div>
          <nav className="flex md:flex-col gap-1">
            <NavLink to="/admin" end data-testid="admin-nav-overview"
              className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-amber-500/15 text-amber-400" : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/60"}`}>
              <LayoutDashboard size={18} /> Companies
            </NavLink>
            {user?.role === "super_admin" && (
              <NavLink to="/admin/security" data-testid="admin-nav-security"
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-amber-500/15 text-amber-400" : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/60"}`}>
                <ShieldAlert size={18} /> Security log
              </NavLink>
            )}
          </nav>
        </div>
        <div className="hidden md:block">
          <div className="text-xs text-slate-500 mb-2 px-3">{user?.email}</div>
          <button onClick={() => nav("/reports")} className="flex items-center gap-2 px-3 py-2 text-sm text-slate-400 hover:text-slate-200 w-full"><ArrowLeft size={16} /> Back to app</button>
          <button onClick={logout} className="flex items-center gap-2 px-3 py-2 text-sm text-red-400 w-full" data-testid="admin-logout-btn"><LogOut size={16} /> Log out</button>
        </div>
        <div className="md:hidden"><BrandMark /></div>
      </aside>
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto"><Outlet /></main>
    </div>
  );
}
